module.exports = __webpack_public_path__ + "img/0-02-0a-968869a3f0939b2cbe0b1ad692c95632642b6e5633443f773de4b9bcd9cdd08c_3c7781ab.6cb73f5d.jpg";